export const SUBDOMAIN = 'subdomain';
export const HOST = 'host';
export const DOMAIN = 'domain';
export const PASSWORD_SPRAY = 'passwordSpray';
export const DATALEAKS = 'dataleaks';
export const CLOUD_ASSET = 'cloudAsset';
export const BUCKET_ASSET = 'bucketAsset';
export const SERVICES_ASSET = 'servicesAsset';
export const SECOND_LEVEL = 'SecondLevel';
export const THIRD_LEVEL = 'ThirdLevel';
export const FORTH_LEVEL = 'ForthLevel';
export const CSV = 'csv';
export const CREDENTIALS = 'credentials';
export const TAGS_SUBDOMAIN = 'tagsSubdomain';
export const TAGS_AUTO = 'tagsAuto';
export const TAGS_DOMAIN = 'tagsDomain';
export const TAGS_ORGANIZATION = 'tagsOrganization';
export const TAGS_CLOUD_ACCOUNT = 'tagsCloudAccount';
export const CLOUD_ACCOUNT = 'cloudAccount';
export const SCAN_SETTINGS = 'scanSettings';

export const CONFIGURATION_ACTION_TYPES = {
  MOVE_SUBDOMAIN: 'moveSubdomain',
  MOVE_IP: 'moveIp',
  ADD_SUBDOMAIN: 'addSubdomain',
  SUPPRESS_SUBDOMAIN: 'suppressSubdomain',
  ADD_HOST: 'addHost',
  ADD_CREDENTIALS: 'addCredentials',
  DELETE_CREDENTIALS: 'deleteCredentials',
  ENABLE_SUBDOMAIN: 'enableSubdomain',
  ADD_DOMAIN: 'addDomain',
  DELETE_DOMAIN: 'deleteDomain',
  COVER_REGION: 'coverRegion',
  ADD_TAGS: 'addTags',
  REMOVE_TAG: 'removeTag',
  UPDATE_TAGS: 'updateTags',
  SUPPRESS_CLOUD_ASSET: 'suppressCloudAsset',
  SUPPRESS_CLOUD_BUCKET: 'suppressCloudBucket',
  ENABLE_CLOUD_ASSET: 'enableCloudAsset',
  ENABLE_CLOUD_BUCKET: 'enableCloudBucket',
  IMPORT_ASSETS_FROM_CSV: 'importAssetsFromCSV',
  ADD_ASSET: 'addAsset',
  PASSWORD_SPRAY: 'passwordSpray',
  TAKEOVER: 'takeover',
  RELEASE: 'release',
  DELETE_USER: 'deleteUser',
  DELETE_PENDING_USER: 'deletePendingUser',
  INVITE_USER: 'inviteUser',
  RESET_PASSWORD: 'resetPassword',
  CHANGE_ROLE: 'changeRole',
  REMOVE_ASSET: 'removeAsset',
};
export const CLOUD_SERVICES_HEADERS = {
  'services.tab.service.name.header': 'serviceName',
  'services.tab.resource.id.header': 'resourceId',
  'services.tab.account.id.header': 'accountId',
  'services.tab.region.header': 'region',
  'services.tab.compliance.violation.header': 'complianceViolation',
};
export const TOP_LEVEL_DOMAINS_HEADERS = {
  'tld.tab.risk.score.header': 'riskScore',
  'tld.tab.validated.header': 'validated',
  'last.scanned.tld': 'lastScanned',
  'tld.tab.sensitivity.header': 'sensitivity',
  'tld.tab.main.asset.header': 'configData',
  'tld.tab.assets.amount.header': 'assets',
};
export const INFRASTRUCTURE_HEADERS = {
  'infrastructure.tab.default.header': 'default',
  'infrastructure.tab.sensitivity.header': 'sensitivity',
  'infrastructure.tab.main.asset.header': 'asset',
  'infrastructure.tab.hosts.and.ports.header': 'hostsPorts',
  'infrastructure.tab.services.header': 'services',
  'infrastructure.tab.waf.header': 'waf',
  'infrastructure.tab.screenshots.header': 'screenshots',
  'infrastructure.tab.technologies.header': 'technologies',
  'infrastructure.tab.last.scanned.header': 'lastScanned',
};
export const LEAKS_HEADERS = {
  'leaksDataTable.source': 'source',
};
export const TECHNOLOGIES_HEADERS = {
  'technologyTabTable.technology': 'technology',
  'technologyTabTable.assets': 'assets',
  'technologyTabTable.cves': 'cves',
  'technologyTabTable.validation.triggered': 'validation',
};
export const SERVICE_TYPES = {
  AMAZON: { icon: 'service-icon-aws', name: 'AWS'},
  CHIME_VOICECONNECTOR: { icon: 'service-icon-chime-voice-connector', name: 'Chime Voice Connector'},
  ROUTE53_HEALTHCHECKS: { icon: 'service-icon-route53-healthchecks', name: 'Route 53 Health Checks'},
  S3: { icon: 'service-icon-s3', name: 'S3'},
  DYNAMODB: { icon: 'service-icon-dynamodb', name: 'Dynamo DB'},
  EC2: { icon: 'service-icon-ec2', name: 'EC2'},
  ROUTE53: { icon: 'service-icon-route53', name: 'Route 53'},
  CLOUDFRONT: { icon: 'service-icon-cloudfront', name: 'CloudFront'},
  GLOBALACCELERATOR: { icon: 'service-icon-global-accelerator', name: 'Amazon Global Accelerator'},
  AMAZON_CONNECT: { icon: 'service-icon-amazon-connect', name: 'Amazon Connect'},
  ROUTE53_HEALTHCHECKS_PUBLISHING: { icon: 'service-icon-route53-healthchecks-publishing', name: 'Route 53 Health Checks Publishing'},
  CHIME_MEETINGS: { icon: 'service-icon-chime-meetings', name: 'Chime Meetings'},
  CLOUDFRONT_ORIGIN_FACING: { icon: 'service-icon-cloudfront-origin-facing', name: 'Cloudfront Origin Facing'},
  CLOUD9: { icon: 'service-icon-cloud9', name: 'Cloud9'},
  CODEBUILD: { icon: 'service-icon-amazon-code-build', name: 'Amazon Code Build'},
  API_GATEWAY: { icon: 'service-icon-api-gateway', name: 'API Gateway'},
  ROUTE53_RESOLVER: { icon: 'service-icon-route53-resolver', name: 'Route53 Resolver'},
  EBS: { icon: 'service-icon-ebs', name: 'AWS EBS'},
  WORKSPACES_GATEWAYS: { icon: 'service-icon-workspaces-gateways', name: 'Amazon Workspaces Gateways'},
  KINESIS_VIDEO_STREAMS: { icon: 'service-icon-kinesis-video-streams', name: 'Kinesis Video Streams'},
  EC2_INSTANCE_CONNECT: { icon: 'service-icon-ec2', name: 'EC2'},
  AMAZON_APPFLOW: { icon: 'service-icon-amazon-appflow', name: 'Amazon Appflow'},
  'Elastic Load Balancing': { icon: 'service-icon-elb', name: 'AWS ELB'},
  'Google Cloud': { icon: 'service-icon-gcp', name: 'GCP'},
  'Compute Engine': { icon: 'service-icon-compute-engine', name: 'Compute Engine'},
  'Exchange - Exchange Online': { icon: 'service-icon-microsoft-exchange', name: 'Microsoft Exchange'},
  Exchange: { icon: 'service-icon-microsoft-exchange', name: 'Microsoft Exchange'},
  'Skype - Skype for Business Online and Microsoft Teams': { icon: 'service-icon-microsoft-teams', name: 'Microsoft Teams'},
  Skype: { icon: 'service-icon-microsoft-teams', name: 'Microsoft Teams'},
  'SharePoint - SharePoint Online and OneDrive for Business': { icon: 'service-icon-sharepoint', name: 'SharePoint Online and OneDrive for Business'},
  'Common - Microsoft 365 Common and Office Online': { icon: 'service-icon-office-365', name: 'Microsoft Office 365 Common'},
  Common: { icon: 'service-icon-office-365', name: 'Microsoft Office 365 Common'},
  Azure: { icon: 'service-icon-azure', name: 'Azure'},
  'Azure Traffic Manager': { icon: 'service-icon-unknown', name: 'Azure Traffic Manager'},
  'Azure Virtual Machines': { icon: 'service-icon-unknown', name: 'Azure Virtual Machines'},
};
export const CONFIGURATION = {
  SUCCESS_MESSAGES_BY_ACTION_TYPE: {
    [CONFIGURATION_ACTION_TYPES.IMPORT_ASSETS_FROM_CSV]: 'Import assets from CSV initiate successfully!',
    [CONFIGURATION_ACTION_TYPES.MOVE_SUBDOMAIN]: 'Subdomain associated successfully!',
    [CONFIGURATION_ACTION_TYPES.MOVE_IP]: 'IP associated successfully!',
    [CONFIGURATION_ACTION_TYPES.ADD_SUBDOMAIN]: 'New subdomain added successfully!',
    [CONFIGURATION_ACTION_TYPES.SUPPRESS_SUBDOMAIN]: 'Subdomain suppressed successfully!',
    [CONFIGURATION_ACTION_TYPES.ENABLE_SUBDOMAIN]: 'Subdomain enabled successfully!',
    [CONFIGURATION_ACTION_TYPES.ADD_HOST]: 'New host added successfully!',
    [CONFIGURATION_ACTION_TYPES.ADD_ASSET]: 'New assets added successfully!',
    [CONFIGURATION_ACTION_TYPES.ADD_CREDENTIALS]: 'New credentials added successfully!',
    [CONFIGURATION_ACTION_TYPES.DELETE_CREDENTIALS]: 'Credentials deleted successfully!',
    [CONFIGURATION_ACTION_TYPES.ADD_DOMAIN]: 'New domain added successfully!',
    [CONFIGURATION_ACTION_TYPES.DELETE_DOMAIN]: 'Domain deleted successfully!',
    [CONFIGURATION_ACTION_TYPES.COVER_REGION]: 'Region domains added successfully!',
    [CONFIGURATION_ACTION_TYPES.ADD_TAGS]: 'New tags added successfully!',
    [CONFIGURATION_ACTION_TYPES.REMOVE_TAG]: 'Tag removed successfully!',
    [CONFIGURATION_ACTION_TYPES.UPDATE_TAGS]: 'Tags list updated successfully!',
    [CONFIGURATION_ACTION_TYPES.ENABLE_CLOUD_ASSET]: 'Cloud assets enabled successfully!',
    [CONFIGURATION_ACTION_TYPES.SUPPRESS_CLOUD_BUCKET]: 'Buckets suppressed successfully!',
    [CONFIGURATION_ACTION_TYPES.SUPPRESS_CLOUD_ASSET]: 'Cloud assets suppressed successfully!',
    [CONFIGURATION_ACTION_TYPES.ENABLE_CLOUD_BUCKET]: 'Buckets enabled successfully!',
    [CONFIGURATION_ACTION_TYPES.PASSWORD_SPRAY]: 'Password scan initiated successfully!',
    [CONFIGURATION_ACTION_TYPES.TAKEOVER]: 'Takeover action initiated successfully!',
    [CONFIGURATION_ACTION_TYPES.RELEASE]: 'Release action initiated successfully!',
    [CONFIGURATION_ACTION_TYPES.DELETE_USER]: 'User deleted successfully!',
    [CONFIGURATION_ACTION_TYPES.DELETE_PENDING_USER]: 'Pending user deleted successfully!',
    [CONFIGURATION_ACTION_TYPES.INVITE_USER]: 'User invitation has been sent successfully!',
    [CONFIGURATION_ACTION_TYPES.RESET_PASSWORD]: 'User password has been reset successfully!',
    [CONFIGURATION_ACTION_TYPES.CHANGE_ROLE]: 'User role has been changed successfully!',
    [CONFIGURATION_ACTION_TYPES.REMOVE_ASSET]: 'Asset removed successfully!',
  },
  AUTO_HIJACK_ACTIONS: {
    release: 'release',
    takeover: 'takeover',
  },
  WAF_ACTIONS: {
    protect: 'protect',
    revert: 'revert',
  },
  DATA_TYPE_REQUESTED: {
    subdomains: 'subdomains',
  },
  INFRASTRUCTURE_ACTIONS_TYPES_SUBDOMAIN: {
    moveSubdomain: 'moveSubdomain',
    moveIp: 'moveIp',
  },
  CLOUD_ACTIONS_TYPES: {
    suppress: 'suppress',
    unsuppressed: 'unsuppressed',
  },
  BUCKET_ACTIONS_TYPES: {
    suppress: 'suppress',
    unsuppressed: 'unsuppressed',
  },
  TLD_ACTIONS_TYPES: {
    settings: 'settings',
    delete: 'delete',
  },
  TLD_ACTIONS_TYPE_ICONS: {
    settings: 'settings',
    delete: 'delete',
  },
  INFRASTRUCTURE_HIJACK_ACTIONS_TYPES: {
    takeOver: 'takeOver',
    release: 'release',
  },
  INFRASTRUCTURE_WAF_ACTIONS_TYPES: {
    protect: 'protect',
    revert: 'revert',
  },
  INFRASTRUCTURE_REMOVE_ACTIONS_TYPES: {
    removeAsset: 'removeAsset',
  },
  INFRASTRUCTURE_ACTIONS_TYPES_HOST: {
    moveIp: 'moveIp',
  },
  INFRASTRUCTURE_SUPPRESS_TYPES: {
    ip: 'ip',
    subdomain: 'subdomain',
    enable: 'enable',
  },
  INFRASTRUCTURE_ACTIONS_TYPES: {
    suppress: ['ip', 'subdomain', 'enable'],
  },
  CONFIG_TYPES: {
    SUBDOMAIN,
    CSV,
    HOST,
    DOMAIN,
    DATALEAKS,
    CLOUD_ASSET,
    BUCKET_ASSET,
    CREDENTIALS,
    TAGS_SUBDOMAIN,
    TAGS_AUTO,
    TAGS_DOMAIN,
    TAGS_ORGANIZATION,
    TAGS_CLOUD_ACCOUNT,
    CLOUD_ACCOUNT,
    SCAN_SETTINGS,
  },
  SOURCE_TYPE: {
    gcp: 'gcp',
    aws: 'aws',
    azure: 'azure',
  },
  CLOUD_STATUS: {
    exposed: 'exposed',
    private: 'private',
  },
  TAB: {
    subdomains: 'subdomains',
    hosts: 'hosts',
    domains: 'domains',
    infrastructure: 'infrastructure',
  },
  FieldType: {
    SUBDOMAIN: 'subdomain',
    BUCKET: 'bucket',
    ASSET: 'asset',
    HOST: 'host',
  },
  SensitivityNumericValue: {
    low: 0,
    medium: 1,
    high: 2,
  },
  SensitivityOptions: {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
  },
  InfrastructureSensitivityOptions: {
    INFORMATIVE: 'informative',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    CRITICAL: 'critical',
  },
};
